import { Button, Card, Collapse, FormGroup, Label } from '@blueprintjs/core';
import React, { useState } from 'react';
import styled from 'styled-components';
import { Box, CustomButton, CustomDatePicker } from 'ui-components'
import InputField from '../../../../components/shared/input-field';
import { EmployeeCountT } from 'ui-io/company-io';


type EmpCountPropsT = {
  changeFormData: (name: string, value: any) => void;
  emp_count: EmployeeCountT[];
};

const EmpCount = ({ emp_count, changeFormData }: EmpCountPropsT) => {
	const [isEmpCountExpanded, setEmpCountExpanded] = useState(false);

	const addEmpCountRow = () => {
		const newRow: EmployeeCountT = {
			year: '',
			count: { from: 0, to: 0 }
		};
		const updatedEmpCount = [...(Array.isArray(emp_count) ? emp_count : []), 
		newRow];
		changeFormData('companyDetail.emp_count',updatedEmpCount)
	};

	const removeEmpCountRow = (index: number) => {
		const updatedEmpCount = emp_count.filter((_, i) => i !== index);
		changeFormData('companyDetail.emp_count',updatedEmpCount)
	};
	const [errorRow, setErrorRow] = useState<number | null>(null);
	const handleCheck = (year: string): boolean => {
		const isYearPresent = emp_count.some((yearSlab) => yearSlab.year === year);
		return isYearPresent;
	}

	const updateEmpCountRow = (index: number, field: string, value: string | number) => {
		const updatedEmpCount = [...emp_count];

		if (field === 'year') {
			updatedEmpCount[index] = {
				...updatedEmpCount[index],
				year: value as string
			};
		} else if (field === 'from') {
			updatedEmpCount[index] = {
				...updatedEmpCount[index],
				count: {
					...updatedEmpCount[index].count,
					from: Number(value) || 0
				}
			};
		} else if (field === 'to') {
			updatedEmpCount[index] = {
				...updatedEmpCount[index],
				count: {
					...updatedEmpCount[index].count,
					to: Number(value) || 0
				}
			};
		}
		changeFormData('companyDetail.emp_count',updatedEmpCount)
	};

	return (
		<>
			<CustomButton
			
				className='mb-sm'
				onClick={() => setEmpCountExpanded(!isEmpCountExpanded)}
				icon={isEmpCountExpanded ? "chevron-down" : "chevron-right"}
			>
				Employee Count
			</CustomButton
			>
			<Collapse isOpen={isEmpCountExpanded}>
				<StyledCard>
					{Array.isArray(emp_count) && emp_count.map((empCount, index) => (
						<>
							<Box key={index} flexDir='row' justify='between'>
								<StyledFormGroup label="Year"	>
									<CustomDatePicker
										value={empCount.year}
										mode="in_year"
										onValueChange={(dates) => {
											const year = dates[0]?.getFullYear().toString();
											if (year && handleCheck(year)) {
												setErrorRow(index);
												updateEmpCountRow(index, 'year', "");
											} else if (year) {
												setErrorRow(null);
												updateEmpCountRow(index, 'year', year);
											}
										}}
									/>

								</StyledFormGroup>
								<InputField
									label='Count'
									inputContainerClass='mt-none'
									name={String(empCount.count.to)}
									placeholder="Enter Current Count"
									type="number"
									value={String(empCount.count.to)}
									onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
										updateEmpCountRow(index, 'to', e.target.value)
									}
									mt='5px'
									mb='5px'
									ptb='5px'
								/>

								{emp_count.length >= 1 &&
								<Box flex='true' justify='center' items='center' mt={'medium'} ml={"small"}>
									<Button
										size="small"
										icon="trash"
										aria-label="delete"
										className='h-35px'
										onClick={() => removeEmpCountRow(index)}
									/>
								</Box>
								}
							</Box>
							{errorRow === index && (
								<Box>
									<Label className="text-danger fs-10">Please Select Unique Year</Label>
								</Box>
							)}
						</>
					))}

					<CustomButton onClick={addEmpCountRow} icon="add" bradius="5px">
						Add
					</CustomButton>

				</StyledCard>
			</Collapse>
		</>
	);
};

export default EmpCount;
const StyledCard = styled(Card)`
	margin-bottom: 10px;
`;

const StyledFormGroup = styled(FormGroup)`
	flex:1.7;
  margin-right: 10px;
`;